import type { CSSObject } from "@ui/utils/theme-tools";
import { scrollbarStyles } from "@ui/css/01.scrollbar/scrollbar.styles";
import { focusOutline } from "@ui/css/02.focus/focus.styles";
import { space } from "ui/src/design-tokens";

export const styles: { [a: string]: CSSObject } = {
    selectedFiltersContainer: {
        display: ["flex"],
        flexDirection: "row",
        flexWrap: ["nowrap", "wrap"],
        overflowX: ["auto", "visible"],
        width: "auto",
        alignItems: "center",
        pt: 4,
        gap: space["0.2"],
        ...scrollbarStyles,
    },
    selectedFiltersItem: {
        display: "flex",
        minWidth: "auto",
        flexDirection: "row",
        alignItems: "center",
        backdropFilter: `blur(7.5px)`,
        gap: space["0.2"],
        height: 10,
        shadow: "base",
        fontWeight: "bold",
        _focusVisible: {
            ...focusOutline,
        },
        fontSize: "desktopBodyTextSmall",
    },
    clearAllFiltersButton: {
        _focusVisible: {
            ...focusOutline,
        },
        fontSize: "desktopBodyTextSmall",
        bgColor: "whiteTransparent",
        backdropFilter: `blur(7.5px)`,
        fontWeight: "bold",
        minWidth: "auto",
        border: "none",
        shadow: "base",
        height: 10,
    },
};
